﻿<div class="powerbi-wrapper">
    <div #dashboardContainer style="height: 800px; width: 100%; border: 1px solid #ccc;">

    </div>
</div>